import {
  FaLaptopCode,
  FaBullseye,
  FaNetworkWired,
} from "react-icons/fa";
import { MdVerified } from "react-icons/md";

export const companyInfo = {
  name: "Accelrix",
  website: "https://accelrix.in/",
  email: "support@accelrix.in",
  contactMail: "support@accelrix.in",
  location: "Bengaluru, Karnataka, India",
  lastUpdated: "February 16, 2026",
  linkedInUrl: "https://www.linkedin.com/company/accelrix/",
  instagramUrl: "https://www.instagram.com/accelrix.in/",
  // googleFormUrl:
  //   "https://docs.google.com/forms/d/e/1FAIpQLScV5JzahTqwSVgx4ve4hc1Oe95VDlp0PmAFKEinZ-xkgIayHw/viewform?usp=dialog",
};

export const internshipDomains = [
  {
    title: "Frontend Web Development",
    overview:
      "Create engaging and responsive user interfaces with HTML, CSS, JavaScript, and popular frameworks like React.",
    topics: ["HTML", "CSS", "JavaScript", "React", "Tailwind"],
    popular: true,
    imageUrl:
      "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893452/Frontend_Web_Development_wtzbvi.jpg",
  },
  {
    title: "Backend Web Development",
    overview:
      "Build robust and scalable backend services and APIs using Node.js, Express, databases, and REST principles.",
    topics: ["Node.js", "Express", "MongoDB", "SQL", "REST APIs"],
    imageUrl:
      "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893796/Backend_Web_Development_umd1y5.jpg",
  },
  {
    title: "Full-Stack Web Development",
    overview:
      "Combine frontend and backend skills to develop complete web applications from scratch.",
    topics: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "REST APIs",
    ],
    popular: true,
    imageUrl:
      "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893811/Full-Stack_Web_Development_weekaj.jpg",
  },
  // {
  //   title: "Data Science",
  //   overview:
  //     "Analyze and interpret data to extract insights using Python libraries and statistical methods.",
  //   topics: ["Python", "Pandas", "NumPy", "Matplotlib", "Machine Learning"],
  //   imageUrl:
  //     "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893446/Data_Science_dwppj5.jpg",
  // },
  {
    title: "Machine Learning",
    overview:
      "Build predictive models and intelligent systems using machine learning algorithms and frameworks.",
    topics: [
      "Machine Learning",
      "TensorFlow",
      "PyTorch",
      "Scikit-learn",
      "Deep Learning",
    ],
    popular: true,
    imageUrl:
      "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893441/Machine_Learning_d9nttw.jpg",
  },
  {
    title: "Generative AI",
    overview:
      "Explore cutting-edge AI models that generate content such as text, images, and code using technologies like GPT and GANs.",
    topics: ["Generative Models", "GPT", "GANs", "Deep Learning", "NLP"],
    new: true,
    imageUrl:
      "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893442/Generative_AI_twg0le.jpg",
  },
  // {
  //   title: "Cyber Security",
  //   overview:
  //     "Learn to safeguard digital assets through ethical hacking, penetration testing, and security best practices.",
  //   topics: [
  //     "Ethical Hacking",
  //     "Penetration Testing",
  //     "Network Security",
  //     "Cryptography",
  //   ],
  //   imageUrl:
  //     "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893441/Cyber_Security_umxwul.jpg",
  // },
  // {
  //   title: "Software Testing",
  //   overview:
  //     "Ensure software quality by learning various testing techniques including manual and automated testing.",
  //   topics: [
  //     "Manual Testing",
  //     "Automation Testing",
  //     "Selenium",
  //     "JUnit",
  //     "Test Planning",
  //   ],
  //   imageUrl:
  //     "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893441/Software_Testing_xkvew1.jpg",
  // },
  {
    title: "Android Development",
    overview:
      "Design and develop Android applications using Kotlin, Java, and Android Studio.",
    topics: ["Kotlin", "Java", "Android Studio", "UI/UX Design", "APIs"],
    popular: true,
    imageUrl:
      "https://res.cloudinary.com/djem0fq9t/image/upload/v1756893441/Android_Development_hpfjyw.jpg",
  },
];

export const faqItems = [
  {
    question: "What kind of projects will I work on?",
    answer:
      "Our internships are project-based. You'll work on real-world projects that help you apply your skills and build an impressive portfolio.",
  },
  {
    question: "Is prior experience required?",
    answer:
      "No prior experience is necessary. However, having basic knowledge in your selected domain will help you get the most out of the internship. Our programs are designed for learners of all levels who are eager to learn and grow.",
  },
  {
    question: "How long do the internships last?",
    answer:
      "Each internship lasts for 1 month, giving you enough time to dive into your chosen track and complete your project.",
  },
  {
    question: "Can I enroll in multiple tracks at once?",
    answer:
      "No, you can only enroll in one domain per month to maintain focus and ensure a quality learning experience. You can join a different track in the following months.",
  },
  {
    question: "When does the internship start?",
    answer:
      "Internships commence on the 1st and 15th of every month and run for a duration of 30 days from the respective batch start date.",
  },
  {
    question: "Will I get Offer Letter?",
    answer: "Yes, you will receive an Offer Letter after selection.",
  },
  {
    question: "How do I submit my internship tasks?",
    answer:
      "We will email you a submission form 15–20 days after you receive your Offer Letter. You'll be required to upload your project to GitHub and share the repository link through the form.",
  },
  {
    question: "When will I receive my certificate?",
    answer:
      "You will receive your certificate after successfully completing all tasks and the project. Certificates are verifiable and are issued starting from the 1st or 2nd of the following month, depending on your batch start date.",
  },
  {
    question: "Is the internship online or offline?",
    answer:
      "All our internships are 100% online, so you can participate from anywhere.",
  },
  {
    question: "Are there any certificates provided after completion?",
    answer:
      "Yes, verifiable certificates will be issued upon successful completion of the internship.",
  },
  // {
  //   question: "Are there any job opportunities after the internship?",
  //   answer:
  //     "Yes, if there are referrals or openings such as walk-in drives, deserving interns may be recommended based on their performance.",
  // },
  {
    question: "How much time should I dedicate daily/weekly?",
    answer:
      "We recommend dedicating around 14 hours per week to make steady progress and complete your projects on time.",
  },
  {
    question: "Are these internships truly free?",
    answer:
      "Yes, all our internship programs at Accelrix are completely free. However, a small documentation fee of ₹99 is required to cover processing and administrative charges.",
  },
];

export const features = [
  {
    icon: <MdVerified />,
    title: "Verified Certificates",
    description:
      "Earn verifiable certificates that validate your skills and efforts—great for your resume and LinkedIn.",
    animation: "animate-fade-in-up",
  },
  {
    icon: <FaNetworkWired />,
    title: "Networking Opportunities",
    description:
      "Join a growing tech community and connect with like-minded learners and future collaborators.",
    animation: "animate-fade-in-up",
  },
  {
    icon: <FaLaptopCode />,
    title: "Hands-On Experience",
    description:
      "Work on real-world projects to gain practical skills and build a strong portfolio.",
    animation: "animate-fade-in-up",
  },
  {
    icon: <FaBullseye />,
    title: "Career Readiness",
    description:
      "Get internship experience that makes your resume stand out and prepares you for future opportunities.",
    animation: "animate-fade-in-up",
  },
];
